export default "__VITE_ASSET__D$GIHhT2__"